<script>
   /**************************************************************/
   /* Svelte component for DFPlot settings                  */
   /**************************************************************/

   import Container from '../controls/Container.svelte';
   import Select  from '../controls/Select.svelte';

   export let params;
   export let res;

   let item = 'both';
   $: params = {
      item
   }
</script>

{#if res  }
<Container label="">
   <p class="title">DoF plot</p>
</Container>
<Container label='Results:'>
   <Select id='resType' bind:value={item} options={['both', 'Nh', 'Nq']} />
</Container>
{/if}
